"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _NostrSystem_instances, _NostrSystem_log, _NostrSystem_sockets, _NostrSystem_handleAuth, _NostrSystem_relayCache, _NostrSystem_profileCache, _NostrSystem_relayMetricsCache, _NostrSystem_profileLoader, _NostrSystem_relayMetrics, _NostrSystem_cleanup;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NostrSystem = void 0;
const debug_1 = __importDefault(require("debug"));
const shared_1 = require("@snort/shared");
const connection_1 = require("./connection");
const query_1 = require("./query");
const relay_metric_handler_1 = require("./relay-metric-handler");
const _1 = require(".");
/**
 * Manages nostr content retrieval system
 */
class NostrSystem extends shared_1.ExternalStore {
    constructor(props) {
        super();
        _NostrSystem_instances.add(this);
        _NostrSystem_log.set(this, (0, debug_1.default)("System"));
        /**
         * All currently connected websockets
         */
        _NostrSystem_sockets.set(this, new Map());
        /**
         * All active queries
         */
        this.Queries = new Map();
        /**
         * NIP-42 Auth handler
         */
        _NostrSystem_handleAuth.set(this, void 0);
        /**
         * Storage class for user relay lists
         */
        _NostrSystem_relayCache.set(this, void 0);
        /**
         * Storage class for user profiles
         */
        _NostrSystem_profileCache.set(this, void 0);
        /**
         * Storage class for relay metrics (connects/disconnects)
         */
        _NostrSystem_relayMetricsCache.set(this, void 0);
        /**
         * Profile loading service
         */
        _NostrSystem_profileLoader.set(this, void 0);
        /**
         * Relay metrics handler cache
         */
        _NostrSystem_relayMetrics.set(this, void 0);
        __classPrivateFieldSet(this, _NostrSystem_handleAuth, props.authHandler, "f");
        __classPrivateFieldSet(this, _NostrSystem_relayCache, props.relayCache ?? new _1.UserRelaysCache(), "f");
        __classPrivateFieldSet(this, _NostrSystem_profileCache, props.profileCache ?? new _1.UserProfileCache(), "f");
        __classPrivateFieldSet(this, _NostrSystem_relayMetricsCache, props.relayMetrics ?? new _1.RelayMetricCache(), "f");
        __classPrivateFieldSet(this, _NostrSystem_profileLoader, new _1.ProfileLoaderService(this, __classPrivateFieldGet(this, _NostrSystem_profileCache, "f")), "f");
        __classPrivateFieldSet(this, _NostrSystem_relayMetrics, new relay_metric_handler_1.RelayMetricHandler(__classPrivateFieldGet(this, _NostrSystem_relayMetricsCache, "f")), "f");
        __classPrivateFieldGet(this, _NostrSystem_instances, "m", _NostrSystem_cleanup).call(this);
    }
    /**
     * Profile loader service allows you to request profiles
     */
    get ProfileLoader() {
        return __classPrivateFieldGet(this, _NostrSystem_profileLoader, "f");
    }
    get Sockets() {
        return [...__classPrivateFieldGet(this, _NostrSystem_sockets, "f").values()].map(a => a.snapshot());
    }
    /**
     * Connect to a NOSTR relay if not already connected
     */
    async ConnectToRelay(address, options) {
        try {
            const addr = (0, shared_1.unwrap)((0, shared_1.sanitizeRelayUrl)(address));
            if (!__classPrivateFieldGet(this, _NostrSystem_sockets, "f").has(addr)) {
                const c = new connection_1.Connection(addr, options, __classPrivateFieldGet(this, _NostrSystem_handleAuth, "f")?.bind(this));
                __classPrivateFieldGet(this, _NostrSystem_sockets, "f").set(addr, c);
                c.OnEvent = (s, e) => this.OnEvent(s, e);
                c.OnEose = s => this.OnEndOfStoredEvents(c, s);
                c.OnDisconnect = (code) => this.OnRelayDisconnect(c, code);
                c.OnConnected = (r) => this.OnRelayConnected(c, r);
                await c.Connect();
            }
            else {
                // update settings if already connected
                (0, shared_1.unwrap)(__classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(addr)).Settings = options;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    OnRelayConnected(c, wasReconnect) {
        if (wasReconnect) {
            for (const [, q] of this.Queries) {
                q.connectionRestored(c);
            }
        }
    }
    OnRelayDisconnect(c, code) {
        __classPrivateFieldGet(this, _NostrSystem_relayMetrics, "f").onDisconnect(c, code);
        for (const [, q] of this.Queries) {
            q.connectionLost(c.Id);
        }
    }
    OnEndOfStoredEvents(c, sub) {
        for (const [, v] of this.Queries) {
            v.eose(sub, c);
        }
    }
    OnEvent(sub, ev) {
        for (const [, v] of this.Queries) {
            v.onEvent(sub, ev);
        }
    }
    /**
     *
     * @param address Relay address URL
     */
    async ConnectEphemeralRelay(address) {
        try {
            const addr = (0, shared_1.unwrap)((0, shared_1.sanitizeRelayUrl)(address));
            if (!__classPrivateFieldGet(this, _NostrSystem_sockets, "f").has(addr)) {
                const c = new connection_1.Connection(addr, { read: true, write: true }, __classPrivateFieldGet(this, _NostrSystem_handleAuth, "f")?.bind(this), true);
                __classPrivateFieldGet(this, _NostrSystem_sockets, "f").set(addr, c);
                c.OnEvent = (s, e) => this.OnEvent(s, e);
                c.OnEose = s => this.OnEndOfStoredEvents(c, s);
                c.OnDisconnect = code => this.OnRelayDisconnect(c, code);
                c.OnConnected = (r) => this.OnRelayConnected(c, r);
                await c.Connect();
                return c;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Disconnect from a relay
     */
    DisconnectRelay(address) {
        const c = __classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(address);
        if (c) {
            __classPrivateFieldGet(this, _NostrSystem_sockets, "f").delete(address);
            c.Close();
        }
    }
    GetQuery(id) {
        return this.Queries.get(id);
    }
    Query(type, req) {
        const existing = this.Queries.get(req.id);
        if (existing) {
            // if same instance, just return query
            if (existing.fromInstance === req.instance) {
                return existing;
            }
            const filters = !req.options?.skipDiff
                ? req.buildDiff(__classPrivateFieldGet(this, _NostrSystem_relayCache, "f"), existing.flatFilters)
                : req.build(__classPrivateFieldGet(this, _NostrSystem_relayCache, "f"));
            if (filters.length === 0 && !!req.options?.skipDiff) {
                return existing;
            }
            else {
                for (const subQ of filters) {
                    this.SendQuery(existing, subQ);
                }
                this.notifyChange();
                return existing;
            }
        }
        else {
            const store = new type();
            const filters = req.build(__classPrivateFieldGet(this, _NostrSystem_relayCache, "f"));
            const q = new query_1.Query(req.id, req.instance, store, req.options?.leaveOpen);
            this.Queries.set(req.id, q);
            for (const subQ of filters) {
                this.SendQuery(q, subQ);
            }
            this.notifyChange();
            return q;
        }
    }
    async SendQuery(q, qSend) {
        if (qSend.relay) {
            __classPrivateFieldGet(this, _NostrSystem_log, "f").call(this, "Sending query to %s %O", qSend.relay, qSend);
            const s = __classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(qSend.relay);
            if (s) {
                const qt = q.sendToRelay(s, qSend);
                if (qt) {
                    return [qt];
                }
            }
            else {
                const nc = await this.ConnectEphemeralRelay(qSend.relay);
                if (nc) {
                    const qt = q.sendToRelay(nc, qSend);
                    if (qt) {
                        return [qt];
                    }
                }
                else {
                    console.warn("Failed to connect to new relay for:", qSend.relay, q);
                }
            }
        }
        else {
            const ret = [];
            for (const [a, s] of __classPrivateFieldGet(this, _NostrSystem_sockets, "f")) {
                if (!s.Ephemeral) {
                    __classPrivateFieldGet(this, _NostrSystem_log, "f").call(this, "Sending query to %s %O", a, qSend);
                    const qt = q.sendToRelay(s, qSend);
                    if (qt) {
                        ret.push(qt);
                    }
                }
            }
            return ret;
        }
        return [];
    }
    /**
     * Send events to writable relays
     */
    BroadcastEvent(ev) {
        for (const [, s] of __classPrivateFieldGet(this, _NostrSystem_sockets, "f")) {
            if (!s.Ephemeral) {
                s.SendEvent(ev);
            }
        }
    }
    /**
     * Write an event to a relay then disconnect
     */
    async WriteOnceToRelay(address, ev) {
        const addrClean = (0, shared_1.sanitizeRelayUrl)(address);
        if (!addrClean) {
            throw new Error("Invalid relay address");
        }
        if (__classPrivateFieldGet(this, _NostrSystem_sockets, "f").has(addrClean)) {
            await __classPrivateFieldGet(this, _NostrSystem_sockets, "f").get(addrClean)?.SendAsync(ev);
        }
        else {
            return await new Promise((resolve, reject) => {
                const c = new connection_1.Connection(address, { write: true, read: true }, __classPrivateFieldGet(this, _NostrSystem_handleAuth, "f")?.bind(this), true);
                const t = setTimeout(reject, 5000);
                c.OnConnected = async () => {
                    clearTimeout(t);
                    await c.SendAsync(ev);
                    c.Close();
                    resolve();
                };
                c.Connect();
            });
        }
    }
    takeSnapshot() {
        return {
            queries: [...this.Queries.values()].map(a => {
                return {
                    id: a.id,
                    filters: a.filters,
                    subFilters: [],
                };
            }),
        };
    }
}
exports.NostrSystem = NostrSystem;
_NostrSystem_log = new WeakMap(), _NostrSystem_sockets = new WeakMap(), _NostrSystem_handleAuth = new WeakMap(), _NostrSystem_relayCache = new WeakMap(), _NostrSystem_profileCache = new WeakMap(), _NostrSystem_relayMetricsCache = new WeakMap(), _NostrSystem_profileLoader = new WeakMap(), _NostrSystem_relayMetrics = new WeakMap(), _NostrSystem_instances = new WeakSet(), _NostrSystem_cleanup = function _NostrSystem_cleanup() {
    let changed = false;
    for (const [k, v] of this.Queries) {
        if (v.canRemove()) {
            v.sendClose();
            this.Queries.delete(k);
            __classPrivateFieldGet(this, _NostrSystem_log, "f").call(this, "Deleted query %s", k);
            changed = true;
        }
    }
    if (changed) {
        this.notifyChange();
    }
    setTimeout(() => __classPrivateFieldGet(this, _NostrSystem_instances, "m", _NostrSystem_cleanup).call(this), 1000);
};
//# sourceMappingURL=data:application/json;base64,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